import { useState, useEffect,useContext } from "react";
import { useDispatch } from "react-redux";
import { useOktaAuth } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import actions from "../actions/User";
import { PEOPLESOFT_TX_GET_USER_ROLE_API } from "../creds";
import { postProxyService } from "../services/BondsServices";
import BondRegistrationContext from "../store/BondRegistrationContext";

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const { oktaAuth, authState } = useOktaAuth();
  const { bondRegistrationContextData, setBondRegistrationContextData } = useContext(BondRegistrationContext);

  useEffect(() => {
    const authenticateUser = async () => {
      if (authState?.isAuthenticated) {

        if (bondRegistrationContextData?.user) {
          console.log("User info already in context. Skipping fetch...");
          setLoading(false);
          return;
        }
        try {
          const info = await oktaAuth.getUser();
          console.log("User is authenticated by Okta", info);

          const requestBody = {
            EmailID: info.email,
          };
       console.log("proxy from ProtectedRoute");
          const proxyRes = await postProxyService(
            PEOPLESOFT_TX_GET_USER_ROLE_API,
            "POST",
            requestBody
          );
          console.log("User from PP_SOFT", proxyRes);
          const user = {
            id: "111",
            uname: info.name,
            role: proxyRes[0].user_role,
            email: info.email,
            law_firm: proxyRes[0].law_firm,
          };
          setBondRegistrationContextData({
            ...bondRegistrationContextData,
            user:user
          });

          dispatch(actions.loginUser(user));
        } catch (error) {
          console.error("Error fetching user info:", error);
        } finally {
          setLoading(false);
        }
      } else {
        const originalUrl = toRelativeUrl(
          window.location.href,
          window.location.origin
        );
        oktaAuth.setOriginalUri(originalUrl);
        oktaAuth.signInWithRedirect();
      }
    };

    authenticateUser();
  }, [authState, oktaAuth, dispatch]);

  if (loading) {
    return <h3>Loading...</h3>;
  }

  return authState?.isAuthenticated ? children : null;
};

export default ProtectedRoute;
